import { CreateOrderRateInterface, OrderRateInterface } from '../exports/Interfaces';
import { DataWrappedResponse } from '../exports/Types';
import BackendApiClient from './BackendApiClient';
import { OrdersApiSliceTags, ordersApiSlice } from '../../store/api-slices';
import { store } from '../../store';

class OrderRatesManager {
  public create = async (
    orderId: number,
    data: CreateOrderRateInterface,
  ): Promise<DataWrappedResponse<OrderRateInterface>> => {
    const res = await BackendApiClient.request({
      method: 'POST',
      url: `/orders/${orderId}/rates`,
      data,
    });

    if (res.success) {
      store.dispatch(ordersApiSlice.util.invalidateTags([OrdersApiSliceTags.Order]));
    }

    return res;
  };
}

export default new OrderRatesManager();
